import { render, staticRenderFns } from "./Knex.vue?vue&type=template&id=b1ea69b8&"
import script from "./Knex.vue?vue&type=script&lang=js&"
export * from "./Knex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports